import(/* webpackMode: "eager", webpackExports: ["MVFooter"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\mv-tutorials\\components\\footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MVHeader"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\app\\mv-tutorials\\components\\header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RevealOnScroll"] */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\components\\reveal-on-scroll.tsx");
;
import(/* webpackMode: "eager" */ "C:\\manish-works\\touches\\lokbharti\\Lokbharati\\node_modules\\next\\dist\\client\\image-component.js");
